export type CurrencyId = string

export enum CurrencyField {
  INPUT = 'input',
  OUTPUT = 'output',
}
